import { ActingUserDto } from '@act/shared/data-transfer-objects';

export function hasPermission(
  user: ActingUserDto,
  permission: string
): boolean {
  return user.permissions.hasOwnProperty(permission);
}
